module.exports = __webpack_public_path__ + "img/bn.b463ac71.svg";